// Firebase SDK init — auth only. Firestore/Storage/Functions replaced by Go backend.

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

import { firebaseConfig, isConfigured, USE_EMULATORS } from "./config.js";

let app = null;
let auth = null;

if (isConfigured) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);

  if (USE_EMULATORS) {
    connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  }
}

export { app, auth, isConfigured };
